/** @format */

import { defaultActions } from '../../core/actionsDefault';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { Auth } from '../auth/Auth';

export function menuReducers(state = {}, action) {
    switch (action.type) {
        case menuConstants.LIST_MENU:
            return {
                menu: action.collections,
            };
        default:
            return { ...state };
    }
}

export const menuConstants = {
    LIST_MENU: 'menu_list',
};

export const menuActions = {
    getMenu: () =>
        defaultActions.getCollection(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/menu_platforms')),
            [
                { name: 'parent', value: 0 },
                { name: 'platformType', value: Auth.getPlatformType() },
            ],
            [{ name: 'menuOrder', value: 'asc' }],
            menuConstants.LIST_MENU
        ),
};
